import { EuroValueSigned } from '@dokucoach/common-types';
import { array, date, object, string } from 'yup';

export interface ICashTransaction {
  id: string;
  voucherNumber: string;
  residentId: string;
  accountId: string;
  date: Date;
  amount: number;
  balance?: number;
  name: string;
  fibuExportId?: string;
}

export interface ICashTransactionInput {
  residentIds: string[];
  accountId: string;
  date: Date;
  amount: number;
  name: string;
}

export interface ICashTransactionFilter {
  residentGroup?: string;
  residentId?: string;
  accountId?: string;
  name?: string;
  startDate?: Date;
  endDate?: Date;
}

export const ICashTransactionInputSchema = object({
  residentIds: array().required().of(string().required()).min(1),
  accountId: string().required(),
  date: date().required(),
  amount: EuroValueSigned.required(),
  name: string().required(),
});

export const ICashTransactionFilterSchema = object({
  // mutually exclusive 'residentGroup' and 'residentId'
  residentGroup: string().optional(),
  residentId: string().optional(),
  accountId: string().optional(),
  name: string().optional(),
  startDate: date().optional(),
  endDate: date().optional(),
});
